import React from 'react'

import SocialSection from '../../../react4xp/components/SocialSection'

function SocialMediaCardsPart({ title, bgColor, cards }) {
    return (
        <SocialSection
            section={{
                bgColor: bgColor
            }}
            title={title}
            social={cards}
        />
    )
}

export default (props) => <SocialMediaCardsPart {...props} />
